module.exports = __webpack_public_path__ + "img/kitesurfen--dark.b1d4279d.svg";